var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAddRowBelow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.25 13.375h5.625v4.375H.25v-4.375ZM1.5 16.5h3.125v-1.875H1.5V16.5ZM.25 7.125h5.625V11.5H.25V7.125ZM1.5 10.25h3.125V8.375H1.5v1.875ZM.25.875h5.625V5.25H.25V.875ZM1.5 4h3.125V2.125H1.5V4Zm14.375 9.375H10.25l2.131 2.244-.881.881-3.75-3.75L11.5 9l.881.881-2.131 2.244h5.625c.345 0 .625-.28.625-.625V4a.625.625 0 0 0-.625-.625h-7.5v-1.25h7.5c1.035 0 1.875.84 1.875 1.875v7.5c0 1.036-.84 1.875-1.875 1.875Z",
    fill: "#000"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAddRowBelow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-row-below.b75854f6accf21dde59528fd560f0786.svg";